import { motion } from "framer-motion";
import { Wrench, ShieldAlert, Layers, Cog } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: Layers,
    title: "Láminas trabadas o atascadas",
    text: "Viruta, rebabas y residuos acumulados bloquean el desplazamiento de la guarda. Desmontamos, limpiamos y realineamos cada lamela hasta recuperar el recorrido suave.",
  },
  {
    num: "02",
    icon: ShieldAlert,
    title: "Wipers y rascadores desgastados",
    text: "Sellos deteriorados dejan pasar refrigerante y contaminantes hacia las guías lineales. Sustituimos wipers con material de especificación original.",
  },
  {
    num: "03",
    icon: Wrench,
    title: "Lamelas deformadas por impacto",
    text: "Golpes de piezas o herramientas deforman las placas de acero. Enderezamos con precisión o fabricamos lamelas nuevas a la medida exacta de tu máquina.",
  },
  {
    num: "04",
    icon: Cog,
    title: "Tracción y sincronización dañadas",
    text: "Resortes, ruedas o mecanismos sincronizados rotos: la guarda no abre ni cierra. Reconstruimos el mecanismo completo y lo probamos en máquina.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 44 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function RepairProblems() {
  return (
    <section
      id="problemas"
      data-testid="repair-problems-section"
      className="gf-section bg-[#061226] relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#00B4D8]" />
            <span className="gf-overline">Manifiesto de taller</span>
          </div>
          <h2 className="font-display font-black text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05] max-w-3xl">
            Problemas frecuentes que{" "}
            <span className="text-[#00B4D8]">resolvemos.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-x-14">
          {CHAPTERS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.article
                key={c.num}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`repair-problem-${c.num}`}
                className="group border-t border-white/10 py-10 flex gap-7"
              >
                <span className="font-display font-black text-5xl lg:text-6xl leading-none gf-text-outline group-hover:text-[#00B4D8] group-hover:[-webkit-text-stroke:0px] transition-all duration-500 shrink-0">
                  {c.num}
                </span>
                <div>
                  <div className="flex items-center gap-3 mb-3">
                    <Icon size={17} className="text-[#00B4D8]" />
                    <h3 className="font-display font-bold text-white text-lg lg:text-xl tracking-tight">
                      {c.title}
                    </h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">{c.text}</p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
